import React, { useEffect } from 'react';
import { Button, FormGroup, Label, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
import { useForm } from 'react-hook-form';

const EFormLinkModal = ({ isOpen, link, isSaving, onSave, onClose }) => {
  const { register, handleSubmit, reset, errors } = useForm();

  useEffect(() => {
    reset({
      title: link?.title || '',
      description: link?.description || '',
      url: link?.url || ''
    });
  }, [link, reset]);

  return (
    <Modal isOpen={isOpen} toggle={onClose} className="md-modal">
      <ModalHeader toggle={onClose}>{link?.id ? 'Edit' : 'Add'} eForm Link</ModalHeader>
      <ModalBody>
        <form onSubmit={handleSubmit(onSave)}>
          <Row>
            <FormGroup className="col-12">
              <Row>
                <Label className="col-3" for="eform-title">Title</Label>
                <div className="col-8 no-padding">
                  <input
                    id="eform-title"
                    name="title"
                    className={'form-control' + (errors.title ? ' is-invalid' : '')}
                    maxLength="200"
                    ref={register({ required: true })}
                  />
                  {errors.title && <div className="invalid-feedback">Title is required.</div>}
                </div>
                <div className="col-1 text-danger no-padding" style={{ paddingLeft: '5px' }}>*</div>
              </Row>
            </FormGroup>

            <FormGroup className="col-12">
              <Row>
                <Label className="col-3" for="eform-description">Description</Label>
                <div className="col-9 no-padding-left">
                  <textarea
                    id="eform-description"
                    name="description"
                    className="form-control"
                    maxLength="1000"
                    rows="3"
                    ref={register}
                  />
                </div>
              </Row>
            </FormGroup>

            <FormGroup className="col-12">
              <Row>
                <Label className="col-3" for="eform-url">URL</Label>
                <div className="col-8 no-padding">
                  <input
                    id="eform-url"
                    name="url"
                    type="url"
                    className={'form-control' + (errors.url ? ' is-invalid' : '')}
                    maxLength="2048"
                    ref={register({ required: true, pattern: /^https?:\/\/.+/i })}
                  />
                  {errors.url && <div className="invalid-feedback">A valid HTTP or HTTPS URL is required.</div>}
                </div>
                <div className="col-1 text-danger no-padding" style={{ paddingLeft: '5px' }}>*</div>
              </Row>
            </FormGroup>

            <div
              className="col-12"
              style={{ marginTop: '30px', borderTop: '1px solid #797979', paddingTop: '15px' }}
            >
              <input
                type="submit"
                disabled={isSaving}
                className="btn btn-outline-secondary"
                value={isSaving ? 'Saving...' : 'Save'}
              />{' '}
              or{' '}
              <Button type="button" outline color="danger" onClick={onClose} disabled={isSaving}>
                Cancel
              </Button>
            </div>
          </Row>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default EFormLinkModal;
